module.exports = __webpack_public_path__ + "static/media/dropdown_icon.a3f2dc42.svg";